import { createStyles, makeStyles, Theme } from 'ui-components';

export default makeStyles((theme: Theme) => createStyles({
  list: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    marginTop: 8,
    padding: 0,
  },
  listItem: {
    padding: 0,
    [theme.breakpoints.down('sm')]: {
      marginBottom: 8,
    },
  },
}), {name: 'FundList'});
